import React, { useState, useEffect } from 'react';
import { getJobs, saveJobs } from '../data/careersData';

const empty = { title: '', postedDate: '', closingDate: '', location: '', description: '' };

const AdminCareers = () => {
  const [jobs, setJobs] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [saved, setSaved] = useState(false);
  const [auth, setAuth] = useState(false);
  const [password, setPassword] = useState('');
  const ADMIN_PASSWORD = 'egbadmin2025';

  useEffect(() => { setJobs(getJobs()); }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) setAuth(true);
    else alert('Incorrect password');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let updated;
    if (editId !== null) {
      updated = jobs.map(j => j.id === editId ? { ...form, id: editId } : j);
    } else {
      const newId = jobs.length > 0 ? Math.max(...jobs.map(j => j.id)) + 1 : 1;
      updated = [...jobs, { ...form, id: newId }];
    }
    saveJobs(updated);
    setJobs(updated);
    setForm(empty);
    setEditId(null);
    setShowForm(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const handleEdit = (job) => {
    setForm({ title: job.title, postedDate: job.postedDate, closingDate: job.closingDate, location: job.location, description: job.description });
    setEditId(job.id);
    setShowForm(true);
    window.scrollTo(0, 0);
  };

  const handleDelete = (id) => {
    if (!window.confirm('Are you sure you want to delete this job?')) return;
    const updated = jobs.filter(j => j.id !== id);
    saveJobs(updated);
    setJobs(updated);
  };

  const handleCancel = () => {
    setForm(empty);
    setEditId(null);
    setShowForm(false);
  };

  if (!auth) return (
    <section className="py-5 bg-light" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-4">
            <div className="card border-0 shadow p-4 rounded-4">
              <h4 className="fw-bold text-center mb-4">Admin Login</h4>
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label className="form-label fw-semibold small">Password</label>
                  <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter admin password" required />
                </div>
                <button type="submit" className="btn btn-primary w-100 fw-bold">Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return (
    <section className="py-5 bg-light" style={{ minHeight: '80vh' }}>
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold mb-0">Careers Admin Panel</h3>
          <div className="d-flex gap-2">
            {!showForm && (
              <button className="btn btn-primary fw-bold" onClick={() => { setForm(empty); setEditId(null); setShowForm(true); }}>
                + Post New Job
              </button>
            )}
            <button className="btn btn-outline-secondary" onClick={() => setAuth(false)}>Logout</button>
          </div>
        </div>

        {saved && <div className="alert alert-success">Job saved successfully!</div>}

        {/* Form */}
        {showForm && (
          <div className="card border-0 shadow-sm p-4 mb-5 rounded-4">
            <h5 className="fw-bold mb-4">{editId ? 'Edit Job' : 'Post New Job'}</h5>
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold small">Job Title *</label>
                  <input type="text" className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="e.g. Full Stack Developer" required />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold small">Work Location *</label>
                  <input type="text" className="form-control" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} placeholder="e.g. Chennai, India" required />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold small">Job Posted Date *</label>
                  <input type="date" className="form-control" value={form.postedDate} onChange={e => setForm({ ...form, postedDate: e.target.value })} required />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold small">Job Closing Date *</label>
                  <input type="date" className="form-control" value={form.closingDate} onChange={e => setForm({ ...form, closingDate: e.target.value })} required />
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold small">Job Description *</label>
                  <textarea className="form-control" rows={5} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Enter full job description..." required></textarea>
                </div>
                <div className="col-12 d-flex gap-2">
                  <button type="submit" className="btn btn-primary fw-bold px-4">{editId ? 'Update Job' : 'Post Job'}</button>
                  <button type="button" className="btn btn-outline-secondary px-4" onClick={handleCancel}>Cancel</button>
                </div>
              </div>
            </form>
          </div>
        )}

        {/* Jobs Table */}
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
          <table className="table table-hover mb-0">
            <thead className="table-dark">
              <tr>
                <th>Job Title</th>
                <th>Location</th>
                <th>Posted Date</th>
                <th>Closing Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length === 0 && (
                <tr><td colSpan={6} className="text-center text-muted py-4">No jobs posted yet.</td></tr>
              )}
              {jobs.map(job => {
                const today = new Date().toISOString().split('T')[0];
                const isActive = job.closingDate >= today;
                return (
                  <tr key={job.id}>
                    <td className="fw-semibold">{job.title}</td>
                    <td>{job.location}</td>
                    <td>{job.postedDate}</td>
                    <td>{job.closingDate}</td>
                    <td><span className={`badge ${isActive ? 'bg-success' : 'bg-secondary'}`}>{isActive ? 'Active' : 'Closed'}</span></td>
                    <td>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(job)}>Edit</button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(job.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default AdminCareers;
